import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=e0000438&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0000438')) {
      api.createRecord('e0000438', component.options)
    } else {
      api.reload('e0000438', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=e0000438&", function () {
      api.rerender('e0000438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8435DR4Gbw8yL/JS/CurrentYear.vue"
export default component.exports